exports.API_URL = "https://graphica-api.herokuapp.com"

const axios = require("axios")

exports.getData = async url => {
  const getResult = await axios.get(url)
  return getResult.data
}

exports.sendData = async (url, data) => {
  await axios
    .post(url, data)
    .then(response => {
      console.log(response)
      return response
    })
    .catch(error => console.log(error))
}
